import React from 'react';
import classnames from 'classnames';

const Spinner = ({ progress }) => (
  <span
    key="spinner"
    className={classnames(
      'circular',
      'multicolor',
      { indeterminate: !progress },
    )}
  >
    <svg className="circle" viewBox="0 0 60 60">
      <circle
        style={progress && ({
          strokeDasharray: `${2 * Math.PI * 25 * progress}, 400`,
        })}
        className="path"
        cx="30"
        cy="30"
        r="25"
      />
    </svg>
  </span>
);

export default Spinner;
